import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  const host = window.location.hostname;
  const environment = host.includes('vercel.app')
    ? 'preview'
    : host.includes('sports-odds-dashboard')
      ? 'production'
      : 'development';

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
